export default __webpack_public_path__ + "static/laughing-tears-a48dc60a14dfe1d3cc8b44360d485566.jpg";